module.exports = "/static/assets/8b65c3c5c1daea486434d91f9e5dba42.png";